export type PushPlataforma = 'android' | 'ios';

export type PushDestino = 'admins' | 'lideres';

/**
 * - no-soportado: el navegador no tiene Web Push.
 * - requiere-instalar: iPhone/iPad en Safari; push solo existe con la app en la pantalla de inicio.
 * - bloqueado: el usuario rechazó el permiso; se cambia desde los ajustes del navegador.
 * - inactivo: se puede activar.
 * - activo: este dispositivo recibe avisos.
 */
export type PushEstado = 'cargando' | 'no-soportado' | 'requiere-instalar' | 'bloqueado' | 'inactivo' | 'activo';

export interface PushClavePublicaResponse {
  success: boolean;
  data: { publicKey: string };
}

export interface PushEnvioResumen {
  destinatarios: number;
  dispositivos: number;
  enviados: number;
}

export interface PushEnvioResponse {
  success: boolean;
  data: PushEnvioResumen;
}

export interface PushEnviarPayload {
  destino: PushDestino;
  titulo: string;
  mensaje: string;
}

export interface PushRoles {
  admin: boolean;
  lider: boolean;
  contador: boolean;
  tesorero: boolean;
  musico: boolean;
  liderAlabanza: boolean;
}

export interface PushDispositivo {
  id: string;
  nombre: string;
  apellido: string;
  roles: PushRoles;
  plataforma: PushPlataforma;
  activadaEn: string | null;
}

export interface PushDispositivosResponse {
  success: boolean;
  data: PushDispositivo[];
}

export interface PushSuscribirDeps {
  registro: () => Promise<ServiceWorkerRegistration>;
  clavePublica: () => Promise<string>;
}

/** Lo que cambia entre Android e iOS al activar push en el dispositivo. */
export interface PushPlataformaCliente {
  readonly plataforma: PushPlataforma;
  /** Estado previo a pedir permiso. `null` si la plataforma puede activarse. */
  bloqueo(): Extract<PushEstado, 'no-soportado' | 'requiere-instalar'> | null;
  /** Rechaza con `PushPermisoDenegadoError` si el usuario no da permiso. */
  suscribir(deps: PushSuscribirDeps): Promise<PushSubscription>;
}

export class PushPermisoDenegadoError extends Error {
  constructor() {
    super('Permiso de notificaciones denegado');
  }
}
